import { render, staticRenderFns } from "./BuyRent.vue?vue&type=template&id=6a4fb336"
import script from "./BuyRent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyRent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports